import { useLanguageData } from '@/common/hooks/useLanguageData';
import { DEFAULT_LEVEL_COLOR } from './getFlamePalette';

export const getLevelColor = (level, fallback = DEFAULT_LEVEL_COLOR) =>
	level?.color || fallback;

export const getLitLevelCount = (levels, currentLevelId) => {
	const hasNoLevels = !levels.length || !currentLevelId;

	if (hasNoLevels) {
		return 0;
	}

	const currentIndex = levels.findIndex((level) => level.id === currentLevelId);

	if (currentIndex < 0) {
		return 0;
	}

	return currentIndex + 1;
};

const getFlameLevels = (scoreProgress) => {
	const levels = Array.isArray(scoreProgress?.levels) ? scoreProgress.levels : [];

	return levels.filter((level) => level?.id);
};

const getProgressPercent = ({ scoreProgress, isMaxLevel }) => {
	const totalPoints = Number(scoreProgress?.total_points) || 0;
	const hasNoProgress = totalPoints === 0 && !isMaxLevel;

	if (hasNoProgress) {
		return 0;
	}

	return Math.max(0, Math.min(100, Number(scoreProgress?.progress_percent) || 0));
};

const getProgressLabel = ({ t, isMaxLevel, progressPercent, nextLevelName }) => {
	if (isMaxLevel) {
		return t.maxLevelLabel;
	}

	return (t.progressToNextLevel || '{percent}% · {name}')
		.replace('{percent}', String(progressPercent))
		.replace('{name}', nextLevelName);
};

export const useLevelLadder = (scoreProgress) => {
	const t = useLanguageData('chat');

	const flameLevels = getFlameLevels(scoreProgress);
	const currentLevel = scoreProgress?.current_level || null;
	const nextLevel = scoreProgress?.next_level || null;
	const currentLevelId = currentLevel?.id || '';
	const litFromLadder = getLitLevelCount(flameLevels, currentLevelId);
	const litCount = litFromLadder || (currentLevelId || currentLevel?.name ? 1 : 0);
	const flameCount = flameLevels.length;
	const isMaxLevel =
		flameLevels.length > 0
			? litCount >= flameLevels.length
			: Boolean(currentLevelId) && !nextLevel?.id;

	const nextLevelName = nextLevel?.name || '';
	const progressPercent = getProgressPercent({ scoreProgress, isMaxLevel });
	const progressLabel = getProgressLabel({ t, isMaxLevel, progressPercent, nextLevelName });

	const accentColor = getLevelColor(currentLevel);
	const levelName = currentLevel?.name || t.levelScoreTitle;
	const levelDescription = currentLevel?.description || t.scoreEmptyState;

	return {
		t,
		flameLevels,
		currentLevel,
		currentLevelId,
		accentColor,
		litCount,
		flameCount,
		isMaxLevel,
		progressPercent,
		levelName,
		levelDescription,
		progressLabel,
	};
};
